import { z } from 'zod';

export const feedbackStatusSchema = z.enum(['open', 'in_progress', 'resolved', 'closed']);
export type FeedbackStatus = z.infer<typeof feedbackStatusSchema>;
export const feedbackMessageSchema = z.string().trim().min(1, '请输入反馈内容').max(4000);
export const feedbackReplySchema = z
  .object({
    message: feedbackMessageSchema,
    clientMessageId: z.string().uuid(),
  })
  .strict();
export const adminFeedbackReplySchema = feedbackReplySchema.extend({
  visibility: z.enum(['public', 'internal']),
});
export const feedbackStatusChangeSchema = z
  .object({
    status: feedbackStatusSchema,
    expectedRevision: z.number().int().nonnegative(),
    reason: z.string().trim().min(1, '请填写处理说明').max(500),
  })
  .strict();
export type FeedbackSummary = {
  id: string;
  message: string;
  status: FeedbackStatus;
  revision: number;
  createdAt: string;
  lastMessageAt: string;
  lastPublicReplySequence: number;
  userReadSequence: number;
  unread: boolean;
};
export type FeedbackMessage = {
  id: string;
  author: 'user' | 'admin';
  visibility: 'public' | 'internal';
  message: string;
  sequence: number;
  createdAt: string;
};
export type FeedbackDetail = FeedbackSummary & {
  messages: FeedbackMessage[];
  nextBeforeSequence: number | null;
};
export type AdminFeedbackSummary = FeedbackSummary & {
  userId: string;
  user: { id: string; name: string; email: string } | null;
};
export type AdminFeedbackDetail = FeedbackDetail & Pick<AdminFeedbackSummary, 'user' | 'userId'>;
export type FeedbackPage<T = FeedbackSummary> = { items: T[]; nextCursor: string | null };
